import { render, staticRenderFns } from "./comparePlatform.vue?vue&type=template&id=25dc2d1f&scoped=true"
import script from "./comparePlatform.vue?vue&type=script&lang=js"
export * from "./comparePlatform.vue?vue&type=script&lang=js"
import style0 from "./comparePlatform.vue?vue&type=style&index=0&id=25dc2d1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dc2d1f",
  null
  
)

export default component.exports